module.exports = __webpack_public_path__ + "static/img/企业简介.05616957.png";